import { gql } from 'graphql-tag';

import { GetLearningPathWithNavigationQuery } from 'src/graphql/generated/graphql';

export const GET_LEARNING_PATH_WITH_NAVIGATION = gql`
  query getLearningPathWithNavigation($slug: String!, $preview: Boolean!) {
    learningPathCollection(
      preview: $preview
      limit: 1
      where: { OR: [{ slug: $slug }, { redirectSlugs_contains_some: [$slug] }] }
    ) {
      items {
        __typename
        sys {
          id
        }
        name
        title
        slug
        learningPathTagline
        learningLevel
        product
        productRole
        coursesCollection(limit: 20, where: { sys: { id_exists: true } }) {
          items {
            sys {
              id
            }
            reward {
              badge
              badgeCdnUrl
            }
            product
            title
            name
            teaser
            slug
            lessonsCollection(limit: 20, where: { sys: { id_exists: true } }) {
              items {
                sys {
                  id
                }
                duration
                title
                slug
                sectionListCollection(limit: 20, where: { sys: { id_exists: true } }) {
                  items {
                    sys {
                      id
                    }
                    title
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export type ContentfulLearningPathWithNavigationResponse = GetLearningPathWithNavigationQuery;
export type ContentfulLearningPathWithNavigation =
  GetLearningPathWithNavigationQuery['learningPathCollection']['items'][0];
export type ContentfullCourse = ContentfulLearningPathWithNavigation['coursesCollection']['items'][0];
